import { gsap } from '../LibrariesImport';

export default class StickyCTA {
	static init() {
		this.cta = document.querySelector('.sticky-cta');

		if (!this.cta) {
			return;
		}

		gsap.to(this.cta, {
			opacity: 0,
			pointerEvents: 'none',
			scrollTrigger: {
				trigger: 'footer',
				start: 'top bottom',
				end: 'top 95%',
				scrub: 1.15,
				once: false,
			}
		});
	}
}